import React, { useState, useEffect } from 'react';
import { Eye, LogOut } from 'lucide-react';

const ImpersonationBanner = () => {
  const [impersonation, setImpersonation] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem('mosaic_impersonating_as');
    const originalToken = localStorage.getItem('mosaic_impersonation_original_token');
    if (data && originalToken) {
      try {
        setImpersonation(JSON.parse(data));
      } catch {
        setImpersonation(null);
      }
    }
  }, []);

  const exitImpersonation = () => {
    const originalToken = localStorage.getItem('mosaic_impersonation_original_token');
    if (originalToken) {
      localStorage.setItem('mosaic_session_token', originalToken);
      localStorage.removeItem('mosaic_impersonation_original_token');
      localStorage.removeItem('mosaic_impersonating_as');
      window.location.href = '/superadmin';
    }
  };

  if (!impersonation) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium z-50" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Eye size={16} />
        <span>
          Viewing as: <strong>{impersonation.name}</strong>
          <span className="ml-2 px-2 py-0.5 bg-white/20 text-xs rounded capitalize">
            {impersonation.role?.replace('_', ' ')}
          </span>
        </span>
      </div>
      <button
        onClick={exitImpersonation}
        className="flex items-center gap-1 px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-sm font-bold transition-colors"
        data-testid="exit-impersonation-btn"
      >
        <LogOut size={14} /> Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
